import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { userModalActions } from 'components/usersModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/**
 * Edit contact action
 *
 * A dropdown menu item that opens the edit contact modal.
 */
export const EditContactAction = ({ user, toggleDropdown, }) => {
    const dispatch = useAppDispatch();
    const handleClick = () => {
        dispatch(userModalActions.show({ user }));
        toggleDropdown();
        analytics.contactsCardEditContactClicked();
    };
    return (_jsx(ButtonList.Item, Object.assign({ icon: "pen", onClick: handleClick }, { children: "Edit contact" })));
};
